module.exports = __webpack_public_path__ + "img/basic-need-min.16023c6a.jpg";